import React from 'react';

const ShortTerm = () => (
  <div style={{ padding: 32 }}>
    <h2>Short Term Courses</h2>
    <p>This is the Short Term Courses page. Add your short term course details here.</p>
  </div>
);

export default ShortTerm;
